import React, { Component, Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import Cookies from 'js-cookie';
import Button from '../../artzu-ui/src/Button';
import _ from 'lodash';
import NewNavButtonGroup from './NewNavButtonGroup';
// import { faAccessibleIcon } from '@fortawesome/free-brands-svg-icons';
// import {
//   faBalanceScale,
//   faUserFriends,
//   faWheelchair,
//   faShieldAlt,
//   faGraduationCap,
// } from '@fortawesome/pro-regular-svg-icons';

import NewCourseSection from './NewCourseSection';

class NewCourseSectionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      done: false,
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false
    };
  }
  // handleCookie = page => {
  //   if (!Cookies.getJSON('Course')) {
  //     const course = {
  //       1: false,
  //       2: false,
  //       3: false,
  //       4: false,
  //       5: false,
  //       6: false
  //     };
  //     course[page] = true;
  //     Cookies.set('Course', course, { expires: 14 });
  //   } else {
  //     const course = _.clone(Cookies.getJSON('Course'));
  //     course[page] = true;
  //     Cookies.set('Course', course, { expires: 14 });
  //   }
  // };
  // handleCookie = page => {
  //   Cookies.set(page, true, { expires: 14 });
  // };

  // componentDidMount() {
  componentWillMount() {
    if (!Cookies.get('Course')) {
      this.setState({ done: false });
    } else {
      const course = Cookies.getJSON('Course');
      let courseCount = 0;
      Object.keys(course).forEach(
        key => {
          if (course[key]) {
            courseCount++;
            this.setState({ [`step${key}`]: true });
          }
        }
        // key => (course[key] ? courseCount++ : null)
      );
      courseCount === 5 ? this.setState({ done: true }) : null;
    }
  }

  render() {
    const { changePage, passed } = this.props;
    const { done, step1, step2, step3, step4, step5 } = this.state;
    return (
      <Fragment>
        <div className="new-course__body--padding">
          <div className="">
            To drive with Autzu Plus you must complete this course. At the
            end there is a short quiz. After you pass, you need to schedule
            the in-person demonstration before you begin.
          </div>
          <div className="new-course__body--margin">
            <NewCourseSection
              page={1}
              {...this.props}
              title="Accessibility and Disability"
              color={!!step1}
              clickDisabled={false}
              // onClick={() => this.handleCookie(1)}
            />
            <NewCourseSection
              page={2}
              {...this.props}
              title="Legal Considerations"
              color={!!step2}
              clickDisabled={!step1}
              // onClick={() => this.handleCookie(2)}
            />
            <NewCourseSection
              page={3}
              {...this.props}
              title="Accessible Customer Service"
              color={!!step3}
              clickDisabled={!step2}
              // onClick={() => this.handleCookie(3)}
            />
            <NewCourseSection
              page={4}
              {...this.props}
              title="Wheelchair & Device Handling"
              color={!!step4}
              clickDisabled={!step3}
              // onClick={() => this.handleCookie(4)}
            />
            <NewCourseSection
              page={5}
              {...this.props}
              title="Trip Safety"
              color={!!step5}
              clickDisabled={!step4}
              // onClick={() => this.handleCookie(5)}
            />
            {done ? (
              <NewCourseSection
                page={6}
                {...this.props}
                title="Quiz"
                color={!!passed}
              />
            ) : null}
            <br />
            <br />
          </div>
        </div>
        {/* <hr />
        <div className="new-course__body__startCourse">
          <Button
            primary
            label="Start Course"
            size="xl"
            fullWidth={true}
            onClick={() => changePage(1, passed)}
          />
        </div> */}
        <div className="new-course__body__footer--desktop">
          <NewNavButtonGroup
            changePage={changePage}
            page={0}
            disabled={!passed}
            passed={passed}
          />
        </div>
      </Fragment>
    );
  }
}

export default NewCourseSectionList;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewCourseSectionList.js